import { render } from "./NuevoAlumnoDialog.vue?vue&type=template&id=2565dc16"
import script from "./NuevoAlumnoDialog.vue?vue&type=script&lang=js"
export * from "./NuevoAlumnoDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__